import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from "redux";
import { thunk } from "redux-thunk";
import { createLogger } from "redux-logger";

import AuthReducer from "../reducers/auth";
import SettingReducer from "../reducers/settings";
import CarePlanReducer from "../reducers/carePlan";
import {
  AssignedClientsReducer,
  ClientReducer,
  AllClientReducer,
} from "../reducers/client";
import ModalReducer from "../reducers/modal";
import { LoadingReducer, SkeletonLoadingReducer } from "../reducers/loading";
import NavigationReducer from "../reducers/navigation";
import WizardReducer from "../reducers/wizard";
import SuspensionReducer from "../reducers/suspension";
import ProvisionReducer from "../reducers/provision";
import ContactsReducer from "../reducers/contacts";
import WristbandsReducer from "../reducers/wristbands";
import GeocommReducer from "../reducers/geocomm";
import UsersReducer from "../reducers/users";
import EsperDeviceReducer from "../reducers/esperDevice";
import AgentsReducer from "../reducers/agents";
import SensorManagerReducer from "../reducers/sensorManager";
import ModulePermissionReducer from "../reducers/modulePermission";
import DashboardReducer from "../reducers/dashboard";
import CommandCenterReducer from "../reducers/commandCenter";

const logger = createLogger({
  collapsed: true,
});

export default function configureStore() {
  let middlewares = [];
  if (process.env.NODE_ENV === "development") {
    middlewares = [...middlewares, thunk, logger];
  } else {
    middlewares = [...middlewares, thunk];
  }

  const mainReducer = combineReducers({
    navigation: NavigationReducer,
    auth: AuthReducer,
    settings: SettingReducer,
    carePlan: CarePlanReducer,
    clients: ClientReducer,
    allClients: AllClientReducer,
    assignedClients: AssignedClientsReducer,
    appModal: ModalReducer,
    appLoader: LoadingReducer,
    skeletonLoader: SkeletonLoadingReducer,
    wizard: WizardReducer,
    suspension: SuspensionReducer,
    provision: ProvisionReducer,
    contacts: ContactsReducer,
    wristbands: WristbandsReducer,
    geocomm: GeocommReducer,
    users: UsersReducer,
    esperDevice: EsperDeviceReducer,
    agents: AgentsReducer,
    sensorManager: SensorManagerReducer,
    modulePermission: ModulePermissionReducer,
    dashboard: DashboardReducer,
    commandCenter: CommandCenterReducer,
  });

  const rootReducer = (state, action) => {
    if (action.type === "AUTH_LOGOUT_SUCCESS") {
      Object.keys(state).forEach((sk) => {
        if (state[sk].savable) {
          return;
        }

        state[sk] = undefined;
      });
    }

    return mainReducer(state, action);
  };

  const store = createStore(
    rootReducer,
    compose(applyMiddleware(...middlewares)),
  );

  return store;
}
